export default "__VITE_ASSET__BbczvH_o__"